import { Banknote, ClipboardList, MousePointerClick } from "lucide-react";
import { Reveal, SectionHeader } from "./Reveal";

const CASH_IMG =
  "https://images.unsplash.com/photo-1565373679107-344d38dbf734?crop=entropy&cs=srgb&fm=jpg&q=80&w=1200&fit=crop";

const CARDS = [
  {
    icon: Banknote,
    title: "Cash Deposit",
    desc: "Receive INR through supported cash deposit payment channels.",
    testid: "cash-deposit-card-1",
  },
  {
    icon: ClipboardList,
    title: "Transparent Orders",
    desc: "Create and track every exchange order from your account.",
    testid: "cash-deposit-card-2",
  },
  {
    icon: MousePointerClick,
    title: "Simple Process",
    desc: "Create an order, follow the payment instructions, submit the required details and track the status.",
    testid: "cash-deposit-card-3",
  },
];

export default function CashDeposit() {
  return (
    <section id="cash-deposit" data-testid="cash-deposit-section" className="section-pad">
      <div className="container-x">
        <div className="grid items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div>
            <Reveal>
              <span className="eyebrow" data-testid="cash-deposit-eyebrow">
                <span className="h-px w-8 bg-emerald-400/60" />
                Payment Processing
              </span>
            </Reveal>
            <Reveal delay={0.08}>
              <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
                INR Cash Deposit <span className="text-gradient">Available</span>
              </h2>
            </Reveal>
            <Reveal delay={0.16}>
              <p className="mt-4 max-w-xl text-base leading-relaxed text-slate-400 sm:text-lg">
                We process INR payments through supported cash deposit channels.
                After creating an exchange order, users will receive the required
                payment instructions inside their account.
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.2} className="relative">
            <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-emerald-400/30 via-white/10 to-teal-400/20 p-[1.5px]">
              <div className="overflow-hidden rounded-[calc(1rem-1px)]">
                <img
                  src={CASH_IMG}
                  alt="INR cash deposit payment channel"
                  width={1200}
                  height={800}
                  loading="lazy"
                  className="h-56 w-full object-cover transition-transform duration-700 hover:scale-105 sm:h-64"
                />
              </div>
            </div>
            <div className="glass-card absolute -bottom-4 left-6 flex items-center gap-2 px-4 py-2.5 shadow-glow-sm">
              <Banknote className="h-4 w-4 text-emerald-400" />
              <span className="text-xs font-semibold text-white">
                Supported deposit channels
              </span>
            </div>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-6 sm:gap-8 md:grid-cols-3">
          {CARDS.map(({ icon: Icon, title, desc, testid }, i) => (
            <Reveal key={title} delay={i * 0.1}>
              <div
                data-testid={testid}
                className="group glass-card h-full p-6 transition-all duration-300 hover:-translate-y-1.5 hover:border-emerald-400/30 hover:shadow-glow-sm sm:p-8"
              >
                <div className="mb-6 grid h-12 w-12 place-items-center rounded-xl border border-emerald-400/25 bg-emerald-400/10 transition-colors duration-300 group-hover:bg-emerald-400/20">
                  <Icon className="h-5.5 h-6 w-6 text-emerald-400" />
                </div>
                <h3 className="font-display text-xl font-semibold tracking-tight text-white">
                  {title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">
                  {desc}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
